import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpCommunicationService } from '../../../../service/http-communication.service';
import { DynamicFormElementDto, DynamicPropertyDto, FilterOperatorEnum, NotificationBulkFilterDto } from '../../../../service/dto';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
	selector: 'app-recipient-filter-modal',
	standalone: false,
	templateUrl: './recipient-filter-modal.component.html',
	styleUrl: './recipient-filter-modal.component.scss'
})
export class RecipientFilterModalComponent implements OnInit {

	filters: DynamicFormElementDto[] = [];
	filterForm!: FormGroup;

	@Input() existingFilters!: NotificationBulkFilterDto[];

	operatorOptions: { label: string; value: FilterOperatorEnum }[] = [
		{ label: 'Equals', value: FilterOperatorEnum.Equal },
		{ label: 'After (>)', value: FilterOperatorEnum.GreaterThan },
		{ label: 'Before (<)', value: FilterOperatorEnum.LessThan },
		{ label: 'After / Equals (>=)', value: FilterOperatorEnum.GreaterThanEqual },
		{ label: 'Before / Equals (<=)', value: FilterOperatorEnum.LessThanEqual }
	];

	constructor(
		private fb: FormBuilder,
		private httpService: HttpCommunicationService,
		private modalRef: NzModalRef,
		private message: NzMessageService) {
		this.filterForm = this.fb.group({
			conditions: this.fb.array([])
		});
	}

	ngOnInit(): void {
		this.httpService.getFilters().subscribe(result => {
			this.filters = result;
			this.populateExistingFilters();
		});
	}

	private populateExistingFilters(): void {
		if (!this.existingFilters?.length) return;

		console.log('Existing filters', this.existingFilters);

		this.conditions.clear();

		this.existingFilters.forEach(f => {
			const config = this.filters.find(cf => cf.id === f.propertyId);
			if (!config) return;

			var val: any = f.value;

			if ((config.dataType === 'DropDownSingle' || config.dataType === 'SelectFromRecords') 
				&& f.value && config.options?.length) {
				val = config.options.find(o => o.value === f.value.value || o.value === f.value) ?? f.value;
			}
			const group = this.createConditionGroup({
				propertyId: f.propertyId,
				propertyName: config.name,
				dataType: config.dataType,
				operator: f.operator,
				value: val
			});

			this.conditions.push(group);
		});
	}


	get conditions(): FormArray {
		return this.filterForm.get('conditions') as FormArray;
	}

	addCondition(): void {
		const unusedFilter = this.filters.find(f => !this.getSelectedProperties().includes(f.id));
		if (!unusedFilter) {
			this.message.error("All filters added already");
			return;
		}

		const group = this.createConditionGroup({
			propertyId: unusedFilter.id,
			propertyName: unusedFilter.name,
			dataType: unusedFilter.dataType,
			operator: undefined,
			value: undefined
		});

		this.conditions.push(group);
	}

	private createConditionGroup(data: Partial<NotificationBulkFilterDto>): FormGroup {
		const group = this.fb.group({
			propertyId: [data.propertyId],
			propertyName: [data.propertyName],
			dataType: [data.dataType],
			operator: [data.operator],
			value: [data.value]
		});

		// Whenever property changes, update metadata from filters
		group.get('propertyId')?.valueChanges.subscribe(propertyId => {
			const config = this.filters.find(f => f.id === propertyId);
			if (config) {
				// reset value depending on dataType
				var  defaultValue: any = undefined;
				if (config.dataType === 'DropDownSingle' || config.dataType === 'SelectFromRecords') {
					defaultValue = undefined; // clear dropdown selection
				} else if (config.dataType === 'Text') {
					defaultValue = '';
				} else if (config.dataType === 'Date' || config.dataType === 'PastDate'  || config.dataType === 'FutureDate') {
					defaultValue = null;
				} else if (config.dataType === 'Boolean') {
					defaultValue = false;
				}
				group.patchValue({
					propertyName: config.name,
					dataType: config.dataType,
					propertyId: config.id,
					value: defaultValue
				}, { emitEvent: false });
			}
		});

		return group;
	}


	private getSelectedProperties(): number[] {
		return this.conditions.controls
			.map(ctrl => ctrl.get('propertyId')?.value)
			.filter(Boolean) as number[];
	}

	removeCondition(index: number): void {
		this.conditions.removeAt(index);
	}

	getPropertyConfig(id: number): DynamicFormElementDto | undefined {
		return this.filters.find(f => f.id === id);
	}

	onSubmit(): void {
		const payload = this.filterForm.value.conditions;
		this.modalRef.close({ filters: payload });
	}

	isPropertySelected(filter: DynamicFormElementDto, index: number): boolean {
		return this.conditions.controls.some((ctrl, i) => i !== index && ctrl.get('propertyId')?.value === filter.id);
	}

}
